import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRouter from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import {
  FETCH_SITE_LIST,
  SET_SITE_LIST,
  FETCH_LOCUS_LIST,
  SET_LOCUS_LIST,
  FETCH_SITE_DATA,
  FETCH_LOCUS_DATA,
  FETCH_POPULATION_DATA,
  SET_POPULATION_DATA,
  SET_DATA,
} from './reducer'

function* fetchSiteList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.SITE_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })
    yield put({ type: SET_SITE_LIST, siteList: response })
  } catch (error) {
    console.log('LAYOUT ERROR', error)
  }
}

function* fetchLocusList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })
    yield put({ type: SET_LOCUS_LIST, locusList: response })
  } catch (error) {
    console.log('LAYOUT ERROR', error)
  }
}

function* fetchSiteData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(action.payload.url, action.payload),
    })

    yield put({
      type: SET_DATA,
      payload: {
        store: action.payload.store,
        data: response,
      },
    })
  } catch (error) {
    console.log('ENTRY ERROR', error)
  }
}

function* fetchLocusData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(action.payload.url, action.payload),
    })

    yield put({
      type: SET_DATA,
      payload: {
        store: action.payload.store,
        data: response,
      },
    })
  } catch (error) {
    console.log('ENTRY ERROR', error)
  }
}

function* fetchPopulationData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.POPULATION_SITES, action.payload),
    })
    yield put({
      type: SET_POPULATION_DATA,
      payload: {
        name: action.payload.population,
        data: response,
      },
    })
  } catch (error) {
    console.log('ENTRY ERROR', error)
  }
}

function* viewSaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
  yield takeLatest(FETCH_SITE_DATA, fetchSiteData)
  yield takeLatest(FETCH_LOCUS_DATA, fetchLocusData)
  yield takeLatest(FETCH_POPULATION_DATA, fetchPopulationData)
}

export default viewSaga
